export default "__VITE_ASSET__MqMUO3Tl__"